import { render } from "./PmidQuery.vue?vue&type=template&id=e2f42428"
import script from "./PmidQuery.vue?vue&type=script&lang=js"
export * from "./PmidQuery.vue?vue&type=script&lang=js"

import "./PmidQuery.vue?vue&type=style&index=0&id=e2f42428&lang=css"

import exportComponent from "/opt/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn});
